/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedTresorerieIndexRouteImport } from './routes/_authed/tresorerie/index'
import { Route as AuthedPaiementsIndexRouteImport } from './routes/_authed/paiements/index'
import { Route as AuthedDepensesIndexRouteImport } from './routes/_authed/depenses/index'
import { Route as AuthedCompteIndexRouteImport } from './routes/_authed/compte/index'
import { Route as AuthedAdminIndexRouteImport } from './routes/_authed/admin/index'
import { Route as AuthedPaiementsNewRouteImport } from './routes/_authed/paiements/new'
import { Route as AuthedPaiementsIdRouteImport } from './routes/_authed/paiements/$id'
import { Route as AuthedDepensesNewRouteImport } from './routes/_authed/depenses/new'
import { Route as AuthedDepensesFournisseursRouteImport } from './routes/_authed/depenses/fournisseurs'
import { Route as AuthedDepensesIdRouteImport } from './routes/_authed/depenses/$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTresorerieIndexRoute = AuthedTresorerieIndexRouteImport.update({
  id: '/tresorerie/',
  path: '/tresorerie/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaiementsIndexRoute = AuthedPaiementsIndexRouteImport.update({
  id: '/paiements/',
  path: '/paiements/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDepensesIndexRoute = AuthedDepensesIndexRouteImport.update({
  id: '/depenses/',
  path: '/depenses/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCompteIndexRoute = AuthedCompteIndexRouteImport.update({
  id: '/compte/',
  path: '/compte/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminIndexRoute = AuthedAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaiementsNewRoute = AuthedPaiementsNewRouteImport.update({
  id: '/paiements/new',
  path: '/paiements/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaiementsIdRoute = AuthedPaiementsIdRouteImport.update({
  id: '/paiements/$id',
  path: '/paiements/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDepensesNewRoute = AuthedDepensesNewRouteImport.update({
  id: '/depenses/new',
  path: '/depenses/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDepensesFournisseursRoute =
  AuthedDepensesFournisseursRouteImport.update({
    id: '/depenses/fournisseurs',
    path: '/depenses/fournisseurs',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedDepensesIdRoute = AuthedDepensesIdRouteImport.update({
  id: '/depenses/$id',
  path: '/depenses/$id',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/login': typeof LoginRoute
  '/depenses/$id': typeof AuthedDepensesIdRoute
  '/depenses/fournisseurs': typeof AuthedDepensesFournisseursRoute
  '/depenses/new': typeof AuthedDepensesNewRoute
  '/paiements/$id': typeof AuthedPaiementsIdRoute
  '/paiements/new': typeof AuthedPaiementsNewRoute
  '/admin/': typeof AuthedAdminIndexRoute
  '/compte/': typeof AuthedCompteIndexRoute
  '/depenses/': typeof AuthedDepensesIndexRoute
  '/paiements/': typeof AuthedPaiementsIndexRoute
  '/tresorerie/': typeof AuthedTresorerieIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthedIndexRoute
  '/depenses/$id': typeof AuthedDepensesIdRoute
  '/depenses/fournisseurs': typeof AuthedDepensesFournisseursRoute
  '/depenses/new': typeof AuthedDepensesNewRoute
  '/paiements/$id': typeof AuthedPaiementsIdRoute
  '/paiements/new': typeof AuthedPaiementsNewRoute
  '/admin': typeof AuthedAdminIndexRoute
  '/compte': typeof AuthedCompteIndexRoute
  '/depenses': typeof AuthedDepensesIndexRoute
  '/paiements': typeof AuthedPaiementsIndexRoute
  '/tresorerie': typeof AuthedTresorerieIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/depenses/$id': typeof AuthedDepensesIdRoute
  '/_authed/depenses/fournisseurs': typeof AuthedDepensesFournisseursRoute
  '/_authed/depenses/new': typeof AuthedDepensesNewRoute
  '/_authed/paiements/$id': typeof AuthedPaiementsIdRoute
  '/_authed/paiements/new': typeof AuthedPaiementsNewRoute
  '/_authed/admin/': typeof AuthedAdminIndexRoute
  '/_authed/compte/': typeof AuthedCompteIndexRoute
  '/_authed/depenses/': typeof AuthedDepensesIndexRoute
  '/_authed/paiements/': typeof AuthedPaiementsIndexRoute
  '/_authed/tresorerie/': typeof AuthedTresorerieIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/depenses/$id'
    | '/depenses/fournisseurs'
    | '/depenses/new'
    | '/paiements/$id'
    | '/paiements/new'
    | '/admin/'
    | '/compte/'
    | '/depenses/'
    | '/paiements/'
    | '/tresorerie/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/depenses/$id'
    | '/depenses/fournisseurs'
    | '/depenses/new'
    | '/paiements/$id'
    | '/paiements/new'
    | '/admin'
    | '/compte'
    | '/depenses'
    | '/paiements'
    | '/tresorerie'
  id:
    | '__root__'
    | '/_authed'
    | '/login'
    | '/_authed/'
    | '/_authed/depenses/$id'
    | '/_authed/depenses/fournisseurs'
    | '/_authed/depenses/new'
    | '/_authed/paiements/$id'
    | '/_authed/paiements/new'
    | '/_authed/admin/'
    | '/_authed/compte/'
    | '/_authed/depenses/'
    | '/_authed/paiements/'
    | '/_authed/tresorerie/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/tresorerie/': {
      id: '/_authed/tresorerie/'
      path: '/tresorerie'
      fullPath: '/tresorerie/'
      preLoaderRoute: typeof AuthedTresorerieIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/paiements/': {
      id: '/_authed/paiements/'
      path: '/paiements'
      fullPath: '/paiements/'
      preLoaderRoute: typeof AuthedPaiementsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/depenses/': {
      id: '/_authed/depenses/'
      path: '/depenses'
      fullPath: '/depenses/'
      preLoaderRoute: typeof AuthedDepensesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/compte/': {
      id: '/_authed/compte/'
      path: '/compte'
      fullPath: '/compte/'
      preLoaderRoute: typeof AuthedCompteIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin/': {
      id: '/_authed/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthedAdminIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/paiements/new': {
      id: '/_authed/paiements/new'
      path: '/paiements/new'
      fullPath: '/paiements/new'
      preLoaderRoute: typeof AuthedPaiementsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/paiements/$id': {
      id: '/_authed/paiements/$id'
      path: '/paiements/$id'
      fullPath: '/paiements/$id'
      preLoaderRoute: typeof AuthedPaiementsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/depenses/new': {
      id: '/_authed/depenses/new'
      path: '/depenses/new'
      fullPath: '/depenses/new'
      preLoaderRoute: typeof AuthedDepensesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/depenses/fournisseurs': {
      id: '/_authed/depenses/fournisseurs'
      path: '/depenses/fournisseurs'
      fullPath: '/depenses/fournisseurs'
      preLoaderRoute: typeof AuthedDepensesFournisseursRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/depenses/$id': {
      id: '/_authed/depenses/$id'
      path: '/depenses/$id'
      fullPath: '/depenses/$id'
      preLoaderRoute: typeof AuthedDepensesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedDepensesIdRoute: typeof AuthedDepensesIdRoute
  AuthedDepensesFournisseursRoute: typeof AuthedDepensesFournisseursRoute
  AuthedDepensesNewRoute: typeof AuthedDepensesNewRoute
  AuthedPaiementsIdRoute: typeof AuthedPaiementsIdRoute
  AuthedPaiementsNewRoute: typeof AuthedPaiementsNewRoute
  AuthedAdminIndexRoute: typeof AuthedAdminIndexRoute
  AuthedCompteIndexRoute: typeof AuthedCompteIndexRoute
  AuthedDepensesIndexRoute: typeof AuthedDepensesIndexRoute
  AuthedPaiementsIndexRoute: typeof AuthedPaiementsIndexRoute
  AuthedTresorerieIndexRoute: typeof AuthedTresorerieIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedDepensesIdRoute: AuthedDepensesIdRoute,
  AuthedDepensesFournisseursRoute: AuthedDepensesFournisseursRoute,
  AuthedDepensesNewRoute: AuthedDepensesNewRoute,
  AuthedPaiementsIdRoute: AuthedPaiementsIdRoute,
  AuthedPaiementsNewRoute: AuthedPaiementsNewRoute,
  AuthedAdminIndexRoute: AuthedAdminIndexRoute,
  AuthedCompteIndexRoute: AuthedCompteIndexRoute,
  AuthedDepensesIndexRoute: AuthedDepensesIndexRoute,
  AuthedPaiementsIndexRoute: AuthedPaiementsIndexRoute,
  AuthedTresorerieIndexRoute: AuthedTresorerieIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
